module.exports = __webpack_public_path__ + "2620c8c2/img/delete-icon.eb7de062.svg";